import styled from 'styled-components';

export const LabelType = styled.label`
  display: block;
  font-family: 'Roboto';
  font-size: 0.875rem;
  font-weight: 300;
  line-height: 1.125rem;
  color: ${props => (props.color ? props.color : 'var(--primary-color)')};
`;
